export class UploadedFile {
  file: File;
  name = '';
  status = 0;
  errors: string[] = [];
  progress = 0;
}
